/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Outcomeresponseother2Inputs */

const en_outcomeresponseother2 = /** @type {(inputs: Outcomeresponseother2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other`)
};

const pt_outcomeresponseother2 = /** @type {(inputs: Outcomeresponseother2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outra`)
};

/**
* | output |
* | --- |
* | "Other" |
*
* @param {Outcomeresponseother2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const outcomeresponseother2 = /** @type {((inputs?: Outcomeresponseother2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Outcomeresponseother2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_outcomeresponseother2(inputs)
	return pt_outcomeresponseother2(inputs)
});
export { outcomeresponseother2 as "outcomeResponseOther" }